module.exports = __webpack_public_path__ + "static/img/banner.95390b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/recruit/banner.jpg
// module id = 4gE+
// module chunks = 8